import { Navbar } from "react-bootstrap";
import Logo from "./Logo";

export default () => {
    return (
        <Navbar className="justify-content-center" expand="lg">
            <Logo/>
        </Navbar>
    );
}